/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportParam } from '../../models/report-param';

export interface ReportParamPut$Params {
  id: number;
  rptid?: number;
      body: ReportParam
}

export function reportParamPut(http: HttpClient, rootUrl: string, params: ReportParamPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportParam>> {
  const rb = new RequestBuilder(rootUrl, reportParamPut.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('rptid', params.rptid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportParam>;
    })
  );
}

reportParamPut.PATH = '/api/ReportParam/{id}';
